import { render, staticRenderFns } from "./TariffsResult.vue?vue&type=template&id=3f52f040&"
import script from "./TariffsResult.vue?vue&type=script&lang=js&"
export * from "./TariffsResult.vue?vue&type=script&lang=js&"
import style0 from "./TariffsResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports